import React from 'react';
import './Sections.scss';

function Section2() {
  return (
    <section className="sections sections-marginBox">
      <p className="sections-title">Looking beyond low interest rates</p>
      <p className="sections-copy">
        Right now, interest rates are still near historic lows. That’s good news for buyers,
        especially those who are currently renting and likely to face higher rents next year.
        “Buyers who obtain a 30-year fixed-rate mortgage now can benefit from today’s low interest
        rates for the next three decades and keep the same mortgage payment for that entire time,”
        says Lautz.
      </p>
      <p className="sections-copy">
        (Explore the potential savings of breaking free from rising rents in this article on{' '}
        <a
          className="hyperLink italic"
          href="https://sponsorcontent.cnn.com/interactive/nar/benefits-of-home-ownership/"
          target="_blank"
          rel="noreferrer"
        >
          The Long-Term Wealth-Building Benefits of Home Ownership
        </a>
        .)
      </p>
      <p className="sections-copy">
        Although low rates might tempt buyers to stretch their budget and expand their price range,
        it’s important to remember that mortgage payments are only one of the costs that homeowners
        have to fit into their budgets. For example, longtime renters may not realize that
        homeowners are responsible for paying real estate taxes that can run into thousands or even
        tens of thousands of dollars per year, depending on the community and on the value of the
        home.
      </p>
      <p className="sections-copy">
        Home insurance premiums also tend to be much higher than renters insurance. And single
        family home buyers have to deal with recurring costs such as lawn care and snow removal,
        while also shouldering responsibility for big-ticket items like roof replacements,
        foundation repairs, appliance replacements, and exterior maintenance.
      </p>
      <p className="sections-copy">
        Buyers should also consider commuting costs and logistics. For instance, does a home in a
        distant suburb make sense for a remote worker who is no longer working from home and now has
        the added expense of commuting to the office 5 days a week? Beyond the work commute, it’s a
        smart idea for buyers to compute distances between homes under consideration and amenities
        such as retail stores, restaurants, and healthcare providers.
      </p>
    </section>
  );
}

export default Section2;
